<template>
  <form @submit.prevent="addUsers">
    <div class="flex-center">
      <ImageInput v-model="avatar">
        <div slot="activator">
          <div v-if="!avatar" class="image-selector">
            <img src="@/assets/images/avatar-select@2x.png" alt="avatar">
          </div>
          <div v-else class="image-selector selected">
            <img :src="avatar.imageURL" alt="avatar">
          </div>
        </div>
      </ImageInput>
    </div>
    <InputDash       
      label="First Name"
      name="firstname"
      :isTextArea="false"
      placeholder="First Name"
      :isDisabled="false"
      v-model="firstname"
      :validation="!this.inValidFields.includes('firstname')"
    />
    <InputDash       
      label="Last Name"
      name="lastname"
      :isTextArea="false"
      placeholder="Last Name"
      :isDisabled="false"
      v-model="lastname"
      :validation="!this.inValidFields.includes('lastname')"
    />
    <InputDash       
      label="Email"
      name="email"
      :isTextArea="false"
      placeholder="Email"
      :isDisabled="false"
      v-model="mail"
      :validation="!this.inValidFields.includes('mail')"
    />
    <InputRadio      
      label="Permissions"
      name="permissions"
      :isDisabled="false"
      v-model="permissionsText"
    />
    <InputSecure       
      label="Password"
      name="password"
      :isTextArea="false"
      placeholder="Password"
      :isDisabled="false"
      :isHidden="false"
      v-model="password"
      :totalChar="10"
      :minChar="8"
      :maxChar="16"
      :isNumberOnly="false"
      :validation="!this.inValidFields.includes('password')"
    />
    <InputSecure       
      label="Pincode"
      name="pincode"
      :isTextArea="false"
      placeholder="Pincode"
      :isDisabled="false"
      :isHidden="false"
      v-model="pincode"
      :totalChar="5"
      :minChar="5"
      :maxChar="5"
      :isNumberOnly="true"
      :validation="!this.inValidFields.includes('pincode')"
    />
    <div class="buttons">
      <BaseButton color="tertiary" :key="1" type="button" size="modal-sm" @click.native="emitClose(true)">
        Cancel
      </BaseButton>
      <BaseButton color="primary" :key="2" type="submit" size="modal-sm">
        Add
      </BaseButton>
    </div>
  </form>
</template>

<script>
import BaseButton from "@/components/base/Button.vue";
import InputDash from "@/components/base/InputDash.vue";
import InputRadio from "@/components/base/InputRadio.vue";
import ImageInput from '@/components/base/ImageInput.vue'
import InputSecure from '@/components/base/InputSecure.vue'

export default {
  components: {
    ImageInput,
    InputDash,
    InputRadio,
    InputSecure,
    BaseButton
  },
  props: {
    title: String,
  },
  data(){
    return {
      firstname : "",
      lastname : "",
      mail : "",
      pincode : "",
      password : "",
      image64 : "",
      permissions : false,
      permissionsText : 'employee',
      avatar: null,
      saving: false,
      saved: false,
      inValidFields: [],
    }
  },
  watch:{
    avatar: {
      handler: function() {
        this.saved = false
      },
      deep: true
    }
  },
  methods: {
    addUsers: function () {
      var that = this

      this.inValidFields = []

      if(this.firstname == "" || /^[a-zA-z0-9-_]*$/.test(this.firstname) == false) {
        this.inValidFields.push("firstname")
      }
      
      if(this.lastname == "" || /^[a-zA-z0-9-_]*$/.test(this.lastname) == false) {
        this.inValidFields.push("lastname")
      }

      if(this.mail == "") {
        this.inValidFields.push("mail")
      }

      if(this.password == "" || this.password.length < 8) {
        this.inValidFields.push("password")
      }

      if(this.pincode == "" || this.pincode.length != 5) {
        this.inValidFields.push("pincode")
      }

      if(this.inValidFields.length == 0) {
        this.$http.post(this.$endpoint + 'management/users/', {
          "userID": "",
          "email": this.mail,
          "firstName": this.firstname,
          "lastName": this.lastname,
          "isAdmin": this.permissionsText == "admin" ? true : false,
          "userPicture": this.avatar != null ? this.avatar.base64 : '',
          "hasImage": ((this.avatar == null || this.avatar.base64 == '') ? false : true), 
          "password": this.password,
          "pincode": this.pincode,
        })
        .then(function (response) {
          that.$emit('closeModal', true);          
          that.$swal(
            'User added!',
            `Your user has been successfully added.`,
            'success'
          );
        })
        .catch(function (error) {
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: ${ error }`,
            'error'
          );
        });
      }
    },
    emitClose(isClicked) {
      this.$emit('closeModal', isClicked);
    },
    uploadImage() {
      this.saving = true
      setTimeout(() => this.savedAvatar(), 1000)
    },
    savedAvatar() {
      this.saving = false
      this.saved = true
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";

.flex-center {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.image-selector,
.image-selector > img{
  height: 100px;
  &:hover {
    cursor: pointer;
  }
  
  &.selected > img {
    height: 96px;
    width: 96px;
    border-radius: 50%;
    border: 1px solid #DDDDDD;
    object-fit: cover;
  }
}

</style>
